/** @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';

import * as Routes from 'statsradio/helpers/constant/Routes';
import CampaignDashboardListing from 'common/modules/campaign/domain/CampaignDashboardListing';
import { Table, Th } from '../CampaignDashboardTable';
import LinkedCampaignsTableRow from './LinkedCampaignsTableRow';

interface Props {
  t: any;
  history: any;

  campaigns: CampaignDashboardListing[];
}

function onCampaignClick(campaignReference: string, history: any) {
  history.push(Routes.CAMPAIGN(campaignReference));
}

function LinkedCampaignsTable({ t, campaigns, history }: Props) {
  return (
    <Table style={{ tableLayout: 'fixed' }} width="100%">
      <thead>
        <tr>
          <Th width="50%">{t('campaignName')}</Th>
          <Th width="30%">{t('linking')}</Th>
          <Th width="20%">{t('start')}</Th>
        </tr>
      </thead>
      <tbody>
        {campaigns.map(c => <LinkedCampaignsTableRow key={c.reference} campaign={c} history={history} onCampaignClick={onCampaignClick} />)}
      </tbody>
    </Table>
  );
}

export default translate('salesDashboard')(withRouter(LinkedCampaignsTable));



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/components/linkedCampaigns/LinkedCampaignsTable.js